import React, { useEffect, useContext } from 'react';
import './Splash.css';
import { useNavigate } from 'react-router-dom';
import uplLogoMain from "../../assets/images/uplLogoMain.png"
import homeLogo from "../../assets/images/homeLogo.svg"
import { ThemeContext } from '../../contexts/ThemeContext';
import uplLogoDark from "../../assets/images/uplLogoDark.svg"

const SplashScreen = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useContext(ThemeContext);

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/sign-in');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className={`splash-screen ${isDarkMode ? "dark-mode" : "light-mode"}`}>
    <div className="logo">
      <img src={isDarkMode ? uplLogoDark: uplLogoMain } alt="UPL Logo" className="logo-img upl-logo" />
      <span className={`divider ${isDarkMode ? "dark-mode" : "light-mode"}`}>|</span>
      <img src={homeLogo} alt="ChatNPP Logo" className="logo-img chatnpp-logo" />
    </div>
    <div className="loader-wrapper">
    <div className={`loader-bar ${isDarkMode ? "dark-mode" : "light-mode"}`}>
    <div className={`loader-fill ${isDarkMode ? "dark-mode" : "light-mode"}`}>
    </div>
    </div>
    </div>
  </div>
  )
};
  

export default SplashScreen;
